// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".google-captcha-policy[data-v-6d265b08]{margin-bottom:21px;line-height:normal}.google-captcha-policy a[data-v-6d265b08]{color:#a363ff;text-decoration:none}", ""]);
// Exports
module.exports = exports;
